module.exports = __webpack_public_path__ + "img/insta6.dab0ff40.jpg";